import { connectAuthEmulator, getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
// Importing the app's config also routes Firestore to the local emulator when
// REACT_APP_USE_EMULATOR=true (see app/utils/firebaseConfig.ts).
import { firebaseApp } from '../../app/utils/firebaseConfig';

export const schoolAuth = getAuth(firebaseApp);
export const schoolDb = getFirestore(firebaseApp);

// Students sign in with custom tokens minted by the (emulated) schoolStudentLogin
// function, so Auth must use the emulator whenever Functions/Firestore do.
if (process.env.REACT_APP_USE_EMULATOR === 'true') {
  try {
    const host =
      typeof window !== 'undefined' && window.location.hostname === '10.0.2.2'
        ? '10.0.2.2'
        : '127.0.0.1';
    connectAuthEmulator(schoolAuth, `http://${host}:9099`, { disableWarnings: true });
  } catch (err) {
    console.error('[school] Failed to connect Auth emulator', err);
  }
}
